module.exports = __webpack_public_path__ + "img/pr-7.78aadc5e.png";